var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_788_33783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6314 9.16309H51.3163C51.4253 9.20432 51.5335 9.25014 51.6443 9.2868C52.2619 9.4893 52.2702 9.51586 51.8276 9.96027C50.7628 11.0281 49.6972 12.0953 48.6306 13.1619C43.5231 18.2828 38.4161 23.4048 33.3098 28.5276C33.0742 28.8102 32.7616 29.0183 32.41 29.1268C32.0961 29.2037 31.767 29.1917 31.4595 29.0922C31.152 28.9927 30.8783 28.8095 30.669 28.5632C24.5236 22.3891 18.3727 16.2193 12.2163 10.0538C11.6666 9.4985 11.6665 9.49851 12.4271 9.24194C12.4958 9.21904 12.5627 9.18966 12.6314 9.16309Z",
    fill: "#FCEFEA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_788_33783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46765 12.3302C9.55287 12.0966 9.63534 11.8621 9.72514 11.6311C9.80761 11.4195 9.93314 11.3563 10.1155 11.5395C10.1879 11.6119 10.263 11.6825 10.3354 11.7549L23.1152 24.5713C23.5257 24.9827 23.5257 24.9855 23.1152 25.396L10.3968 38.1501C9.84701 38.6998 9.84701 38.6999 9.59319 37.9623C9.55471 37.8523 9.50889 37.7441 9.46582 37.6351L9.46765 12.3302Z",
    fill: "#FCEFEA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_788_33783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9286 40.8265C25.8198 40.8265 19.7111 40.8265 13.6023 40.8265C13.1188 40.8389 12.6364 40.7718 12.1747 40.6277C11.7486 40.4847 11.7248 40.3976 12.04 40.0778C13.6832 38.4285 15.328 36.7791 16.9743 35.1298C19.6109 32.4853 22.2468 29.8399 24.8821 27.1936C25.3128 26.7611 25.3164 26.762 25.737 27.1826C26.803 28.2498 27.8687 29.3188 28.934 30.3897C29.32 30.8146 29.7906 31.154 30.3156 31.3861C30.8407 31.6182 31.4084 31.7378 31.9825 31.7373C32.5565 31.7368 33.124 31.6161 33.6486 31.383C34.1732 31.15 34.6432 30.8098 35.0284 30.3842C36.1069 29.3084 37.19 28.2373 38.2502 27.1441C38.5397 26.8454 38.7203 26.8298 39.0236 27.1349C43.3064 31.4471 47.5957 35.7538 51.8913 40.055C52.2496 40.4151 52.2276 40.482 51.7328 40.6423C51.2978 40.7738 50.8447 40.8357 50.3904 40.8256C44.2358 40.8237 38.0819 40.824 31.9286 40.8265Z",
    fill: "#FCEFEA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_788_33783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5095 24.9901C54.5095 28.9272 54.5095 32.8639 54.5095 36.8003C54.5163 37.2839 54.4298 37.7643 54.2548 38.2152C54.0954 38.6165 54.034 38.6339 53.7206 38.3205C52.7127 37.3126 51.7203 36.3046 50.7169 35.2967C47.4384 32.0114 44.1592 28.7271 40.8794 25.4436C40.4139 24.9781 40.4139 24.9772 40.8638 24.5273L53.5795 11.7759C54.0725 11.282 54.1137 11.2966 54.3354 11.9692C54.4579 12.3604 54.5161 12.769 54.5077 13.1788C54.5071 17.1165 54.5077 21.0536 54.5095 24.9901Z",
    fill: "#FCEFEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_788_33783",
    x: 2.66403,
    y: -0.0000343323,
    width: 58.6358,
    height: 38.3399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.58156
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_788_33783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_788_33783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_788_33783",
    x: 0.3027,
    y: 2.26852,
    width: 32.2833,
    height: 45.4366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.58156
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_788_33783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_788_33783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_788_33783",
    x: 2.66305,
    y: 17.705,
    width: 58.6358,
    height: 32.2862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.58156
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_788_33783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_788_33783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_788_33783",
    x: 31.3652,
    y: 2.26852,
    width: 32.3077,
    height: 45.4327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.58156
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_788_33783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_788_33783",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailClose);
export default __webpack_public_path__ + "static/media/mail-close.6dd04b27542e5a74d001398a9958fd58.svg";
export { ForwardRef as ReactComponent };